import React from 'react';
import {
  CostPerCharFromFlagFeature,
  ConcurrentCCRFeature,
} from './SharedApiFeatures';
import purchaseAdditionalCCRFeatures from './PurchaseAdditionalCCR';
import CheckOrCross from '../Shared/CheckOrCross';

const FEATURE_NAME = 'tts-async';

const ttsBatchFeatures = ({ packages, ttsConfig }) => ({
  enabled: {
    key: 'tts-batch-enabled',
    label: 'ttsBatch',
    values: packages.map((pkg) => (
      <CheckOrCross
        key={pkg.code}
        isCheck={!!pkg?.features?.includes(FEATURE_NAME)}
      />
    )),
  },
  costPerCharacter: {
    key: 'tts-batch-cost-per-char',
    label: 'costPerCharacter',
    values: packages.map((pkg) => (
      <CostPerCharFromFlagFeature
        key={pkg.code}
        pkg={pkg}
        creditPerChar={ttsConfig?.creditPerChar}
        featureName={FEATURE_NAME}
      />
    )),
    tooltipContent: 'tooltipBasicVoice',
  },
  concurrentCCR: {
    key: 'tts-batch-ccr',
    label: 'concurrentAPIRequests',
    values: packages.map((pkg) => (
      <ConcurrentCCRFeature
        key={pkg.code}
        pkg={pkg}
        ccr={pkg?.apiCcr?.tts?.async}
      />
    )),
  },
  purchaseAdditionalCCR: {
    key: 'tts-batch-additional-ccr',
    label: 'purchaseAdditionalCCR',
    values: purchaseAdditionalCCRFeatures({ packages }),
  },
});

export default ttsBatchFeatures;
